const React = require('react');

const Magnifier = React.createClass({
  propTypes: {
    // the size of the magnifier window
    size: React.PropTypes.number.isRequired,

    // mouse coords
    mouseX: React.PropTypes.number.isRequired,
    mouseY: React.PropTypes.number.isRequired,

    // source and native dimensions of image
    image: React.PropTypes.shape({
      src: React.PropTypes.string.isRequired,
      nativeWidth: React.PropTypes.number.isRequired,
      nativeHeight: React.PropTypes.number.isRequired
    }).isRequired,

    // bounding rectangle of image element
    imageRect: React.PropTypes.shape({
      top: React.PropTypes.number.isRequired,
      right: React.PropTypes.number.isRequired,
      bottom: React.PropTypes.number.isRequired,
      left: React.PropTypes.number.isRequired
    }).isRequired,
  },

  render() {
    let props = this.props;
    let halfSize = props.size / 2;
    let imageRect = props.imageRect;

    let zoomFactorX = props.image.nativeWidth / imageRect.width;
    let zoomFactorY = props.image.nativeHeight / imageRect.height;

    let bgX = -((props.mouseX - imageRect.left) * zoomFactorX - halfSize);
    let bgY = -((props.mouseY - imageRect.top) * zoomFactorY - halfSize);

    let isVisible = imageRect.left <= props.mouseX &&
      props.mouseX <= imageRect.right &&
      imageRect.top <= props.mouseY &&
      props.mouseY <= imageRect.bottom &&
      props.mouseX > 0 &&
      props.mouseY > 0;

    return (
      <div className='uc-magnifier-wrapper' style={{
        position: 'fixed',
        display: isVisible ? 'block' : 'none',
        top: props.mouseY,
        left: props.mouseX,
        width: props.size,
        height: props.size,
        marginLeft: -halfSize,
        marginTop: -halfSize,
        borderRadius: '8px',
        boxShadow: `1px 1px 6px rgba(0,0,0,0.3)`,
        zIndex: 9
      }}>
        <div className='uc-magnifier-image' style={{
          width: props.size,
          height: props.size,
          backgroundImage: `url('${props.image.src}')`,
          backgroundSize: `${props.image.nativeWidth}px ${props.image.nativeHeight}px`,
          backgroundPosition: `${bgX}px ${bgY}px`,
          backgroundRepeat: 'no-repeat',
          borderRadius: '8px',
          cursor: 'none'
        }} />
      </div>
    );
  }
});

module.exports = Magnifier;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/Magnifier.jsx